import React, { FunctionComponent, ReactElement } from "react";
import { useIntl } from "react-intl";
import { FooterSection, LogosByLocales } from "@Types/cart";
import CartFooterItem from "./CartFooterItem";
import bartoliniLogo from "./images/bartolini.png";
import colisPriveLogo from "./images/colis_prive.png";
import colissimoLogo from "./images/colissimo.png";
import dhlLogo from "./images/dhl.png";
import diduenjoyLogo from "./images/diduenjoy.png";
import giftLogo from "./images/gift.png";
import laposteLogo from "./images/laposte.png";
import mastercardLogo from "./images/mastercard.png";
import paypalLogo from "./images/paypal.png";
import posteItalianeLogo from "./images/poste_italiane.png";
import royalAirMailLogo from "./images/royal_air_mail.png";
import tipsaLogo from "./images/tipsa.png";
import tntLogo from "./images/tnt.png";
import visaLogo from "./images/visa.png";
import "./style.scss";

const CartFooter: FunctionComponent = (): ReactElement => {
  const intl = useIntl();

  const logosByLocales: LogosByLocales = {
    en: {
      deliveryLogos: [dhlLogo, royalAirMailLogo],
      paymentLogos: [mastercardLogo, visaLogo, paypalLogo],
    },
    es: {
      deliveryLogos: [dhlLogo, tipsaLogo],
      paymentLogos: [mastercardLogo, visaLogo, paypalLogo],
    },
    fr: {
      deliveryLogos: [colisPriveLogo, colissimoLogo, tntLogo, laposteLogo],
      paymentLogos: [mastercardLogo, visaLogo, paypalLogo],
    },
    it: {
      deliveryLogos: [bartoliniLogo, dhlLogo, posteItalianeLogo],
      paymentLogos: [mastercardLogo, visaLogo, paypalLogo],
    },
  };

  const packagingLogos: string[] = [giftLogo];
  const satisfactionGuaranteeLogos: string[] = [diduenjoyLogo];

  const sections: FooterSection[] = [
    {
      description: intl.formatMessage({ id: "cheerz_CartFooter_secured_payment_description" }),
      id: 1,
      link: {
        href: "https://support.cheerz.com/hc/en-us/sections/203722598-Payment-and-security",
        text: intl.formatMessage({ id: "cheerz_CartFooter_more_infos" }),
      },
      logos: logosByLocales[intl.locale].paymentLogos,
      title: intl.formatMessage({ id: "cheerz_CartFooter_secured_payment_title" }),
    },
    {
      additionalInfo: intl.formatMessage({ id: "cheerz_CartFooter_package_description_ps" }),
      description: intl.formatMessage({ id: "cheerz_CartFooter_package_description" }),
      id: 2,
      logos: packagingLogos,
      title: intl.formatMessage({ id: "cheerz_CartFooter_package_title" }),
    },
    {
      description: intl.formatMessage({ id: "cheerz_CartFooter_delivery_description" }),
      id: 3,
      link: {
        href: "https://support.cheerz.com/hc/en-us/categories/115001947647-Delivery",
        text: intl.formatMessage({ id: "cheerz_CartFooter_more_infos" }),
      },
      logos: logosByLocales[intl.locale].deliveryLogos,
      title: intl.formatMessage({ id: "cheerz_CartFooter_delivery_title" }),
    },
    {
      additionalInfo: intl.formatMessage({ id: "cheerz_CartFooter_sav_description_2" }),
      description: intl.formatMessage({ id: "cheerz_CartFooter_sav_description" }),
      id: 4,
      logos: satisfactionGuaranteeLogos,
      title: intl.formatMessage({ id: "cheerz_CartFooter_sav_title" }),
    },
  ];

  return (
    <div className="CartFooter">
      {sections.map((section) => (
        <CartFooterItem key={section.id} {...section} />
      ))}
    </div>
  );
};

export default CartFooter;
